import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import type { CountryData } from '@go-modules/interfaces/country-data';
import { NgxCountryService } from '@go-modules/services/country/country.service';
import { distinctUntilChanged, Observable, Subject, takeUntil, tap } from 'rxjs';

@Component({
	selector: 'country-picker',
	templateUrl: './country-picker.component.html',
	styleUrls: ['./country-picker.component.scss'],
	standalone: false
})
export class CountryPickerComponent implements OnDestroy {
	@Output() public countryChange: EventEmitter<string> = new EventEmitter<string>();

	public defaultCountryCode = 'US';
	public selectedCountry = new UntypedFormControl();
	public countries$: Observable<CountryData[]> = this.countryService.getCountries().pipe(
		tap((countries) => {
			const defaultCountry = countries.find((country) =>
				country.code === this.defaultCountryCode
			);
			if (defaultCountry) {
				this.selectedCountry.setValue(defaultCountry);
			}
		})
	);
	private countryChanges$ = this.selectedCountry.valueChanges.pipe(
		distinctUntilChanged(),
		tap((country: CountryData | null) => {
			if (country) {
				this.countryChange.emit(country.code);
			}
		})
	);
	private destroy$ = new Subject<void>();

	constructor (
		private countryService: NgxCountryService
	) {
		this.countryChanges$.pipe(
			takeUntil(this.destroy$)
		).subscribe();
	}

	public ngOnDestroy (): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
